/**
 * @file LandingScreen.jsx
 * @location src/components/landing/LandingScreen.jsx
 * @role 비로그인 진입 랜딩페이지 — 한국 1인 SaaS 컴팩트 톤(히어로+기능+가격+FAQ+클로징 5섹션).
 *   SupabaseGate 가 phase 'signin' 기본 화면으로 렌더. CTA → onStart(신규)/onLogin(로그인) 으로 LoginScreen 전환.
 *   섹션 본문은 LandingBody. 히어로 우측은 실제 콕핏(안 읽음/읽음/완료) 미니 목업.
 */
import { LandingBody } from './LandingBody';
import '../../styles/landing.css';

const SHOT_ROWS = [
  { who: '옥다온',   task: '청구서 발송',         s: 'done',   label: '완료' },
  { who: '마윤슬',   task: '재고 점검',           s: 'read',   label: '읽음' },
  { who: '변새봄',   task: '주간 미팅 자료 준비',  s: 'unread', label: '안 읽음' },
  { who: '선우라온', task: '주간 보고서 작성',    s: 'read',   label: '읽음' },
];

// 베타: 판매 전이라 환불·사업자정보는 미노출(전자상거래법은 판매 시 의무). 데이터 수집 관련 2개만.
const LEGAL = [
  { href: '/legal/terms.html',     label: '이용약관' },
  { href: '/legal/privacy.html',   label: '개인정보처리방침' },
];

/**
 * @param {{ onStart: () => void, onLogin: () => void }} props
 */
export function LandingScreen({ onStart, onLogin }) {
  return (
    <div className="landing">
      <header className="lp-header">
        <div className="lp-wrap lp-nav">
          <div className="lp-logo">온점<i className="lp-logo-dot" aria-hidden="true" /></div>
          <nav className="lp-nav-links">
            <a href="#lp-feat">기능</a><a href="#lp-beta">베타</a><a href="#lp-faq">FAQ</a><a href="/guide/">가이드</a>
          </nav>
          <div className="lp-nav-cta">
            <button className="lp-login" onClick={onLogin}>로그인</button>
            <button className="lp-btn-primary" onClick={onStart}>무료로 시작</button>
          </div>
        </div>
      </header>

      <div className="lp-wrap">
        <div className="lp-hero">
          <div>
            <span className="lp-eyebrow">🚀 무료 오픈베타 · 매니저 1명이 이끄는 팀</span>
            <h1>지시 <span className="em">→</span> 읽음 <span className="em">→</span> 완료<span className="lp-period">.</span></h1>
            <p className="lp-lead">보낸 일이 지금 어디 있는지, 한눈에 보입니다.</p>
            <p className="lp-sub">업무를 보내면 「읽음」으로 도착하고, 「완료」로 돌아옵니다. 일보·검수·승인 버튼 없이, 상태는 두 단계뿐.</p>
            <div className="lp-cta-row">
              <button className="lp-btn-primary lg" onClick={onStart}>무료 베타 시작</button>
              <button className="lp-btn-ghost" onClick={onLogin}>로그인</button>
            </div>
            <div className="lp-trial">지금은 무료 오픈베타 · 카드 등록 없이 1분 시작</div>
          </div>
          <div className="lp-shot">
            <div className="lp-shot-top">
              <span className="lp-dot" /><span className="lp-dot" /><span className="lp-dot" />
              <span className="lp-shot-title">업무 — 매니저</span>
            </div>
            {SHOT_ROWS.map((r) => (
              <div className="lp-srow" key={r.who}>
                <span className="lp-who">{r.who}</span>
                <span className="lp-task">{r.task}</span>
                <span className={`lp-pill ${r.s}`}>{r.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <LandingBody onStart={onStart} />

      <footer className="lp-footer">
        <div className="lp-wrap lp-foot">
          <div className="lp-logo">온점<i className="lp-logo-dot" aria-hidden="true" /></div>
          <div className="lp-legal">
            <a href="/guide/">가이드</a>
            {LEGAL.map((l) => (
              <a key={l.href} href={l.href} target="_blank" rel="noopener noreferrer">{l.label}</a>
            ))}
          </div>
          <div className="lp-copy">© 2026 온점 · 운영: Ra Unghyeon · 문의: support@onjeom.com</div>
        </div>
      </footer>
    </div>
  );
}
